<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="qv-tble-header">
    <span class="heading">Trains</span>
    <div class="pdf-icon">
        <span></span>
        <input type="button" value="Download" class="p-button-secondary pull-right" (click)="downloadTrainExcel()">
    </div>
    <strong class="paginnatiom" *ngIf="totalRecords"> Total records {{locoDataTable.filteredValue !== undefined && locoDataTable.filteredValue !== null ? locoDataTable?.filteredValue?.length : totalRecords}}</strong> 
</div>
<div class="query-view-tables clear">
    <p-table #dt [value]="loadData?.data"  scrollable="true" [rows]="100" [totalRecords]="totalRecords"
        scrollHeight="{{scrollHeightTrainTable}}" id="queryViewTrainResults" scrollWidth="100%">

        <ng-template pTemplate="header">
            <tr>
                <th class="qv-serial">#</th>
                <th pSortableColumn="terminal" class="blue-bold qv-terminal" >{{configData.queryViewLabel.terminal}}
                    <p-sortIcon field="terminal"></p-sortIcon>
                </th>
                <th pSortableColumn="trainId" class="blue-bold qv-train-id">{{configData.queryViewLabel.train}} 
                    <p-sortIcon field="trainId"></p-sortIcon>
                </th>
                <th pSortableColumn="units" class="qv-units">{{configData.queryViewLabel.units}} 
                    <p-sortIcon field="units"></p-sortIcon>
                </th>
                <th pSortableColumn="etd"  class="qv-etd">{{configData.queryViewLabel.etd}} 
                    <p-sortIcon field="etd"></p-sortIcon>
                </th>
                <th pSortableColumn="lastReportingDateTime"  class="qv-rep-time-type-date">{{configData.queryViewLabel.lastReporting}}
                     <p-sortIcon field="lastReportingDateTime"></p-sortIcon>
                    </th>
                <th pSortableColumn="lastReportingType"  class="qv-rep-type">{{configData.queryViewLabel.lastReporting}} {{configData.queryViewLabel.type}} 
                    <p-sortIcon field="lastReportingType"></p-sortIcon>
                </th>
                <th pSortableColumn="lastReportingCityState" class="qv-city-state">{{configData.queryViewLabel.lastReporting}} {{configData.queryViewLabel.city}} {{configData.queryViewLabel.state}} 
                    <p-sortIcon field="lastReportingCityState"></p-sortIcon>
                </th>
                <th pSortableColumn="oprtngRegionName" [style]="{'width':'150px'}">{{configData.queryViewLabel.oprRegion}} 
                    <p-sortIcon field="oprtngRegionName"></p-sortIcon>
                </th>
                <th pSortableColumn="oprtngZoneName"  [style]="{'width':'165px'}">{{configData.queryViewLabel.oprZone}} 
                    <p-sortIcon field="oprtngZoneName"></p-sortIcon>
                </th>
                <th pSortableColumn="tmc"  class="qv-tmc-status">{{configData.queryViewLabel.tmc}} {{configData.queryViewLabel.status}} 
                    <p-sortIcon field="tmc"></p-sortIcon>
                </th>
                <th class="qv-locomotives">{{configData.queryViewLabel.locomotivesWithBrackets}}</th>
            </tr>
            <tr>
                <th></th>
                <th>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'terminal', 'contains')" class="p-column-filter p-inputtext">
                </th>
                <th>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'trainId', 'contains')" class="p-column-filter p-inputtext">
                </th>
                <th>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'units', 'contains')" class="p-column-filter p-inputtext">
                </th>
                <th>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'etd', 'contains')" class="p-column-filter p-inputtext">
                </th>
                <th>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'lastReportingDateTime', 'contains')" class="p-column-filter p-inputtext">
                </th>
                <th>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'lastReportingType', 'contains')" class="p-column-filter p-inputtext">
                </th>
                <th>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'lastReportingCityState', 'contains')" class="p-column-filter p-inputtext">
                </th>
                <th>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'oprtngRegionName', 'contains')" class="p-column-filter p-inputtext">
                </th>
                <th>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'oprtngZoneName', 'contains')" class="p-column-filter p-inputtext">
                </th>
                <th>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'tmc', 'contains')" class="p-column-filter p-inputtext">
                </th>
                <th>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'locoData', 'contains')" class="p-column-filter p-inputtext">
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
            <tr>
                <td class="qv-serial">
                    <span>{{rowIndex + 1}}</span>
                </td>
                <td class="blue-bold qv-terminal">
                    <span (click)="goToTerminal(data['terminal'])">{{data['terminal']}}</span>
                </td>
                <td class="blue-bold qv-train-id">
                    <span (click)="goToTrain(data['trainId'])" id="train{{rowIndex}}{{data['trainId']}}" 
                    (contextmenu)='$event.preventDefault(); setOverlayLinks("train"); locomotiveOverlayPosition($event, overlayMenuLinks, data, "train")'>{{data['trainId']}}</span>
                </td>
                <td class="qv-units">
                    <span>{{ data['units']  ? data['units'] : '-'}}</span>
                </td>
                <td class="qv-etd">
                    <span>{{ data['etd']  ? data['etd'] : '-'}}</span>
                </td>
                <td class="qv-rep-time-type-date">
                    <span>{{ data['lastReportingDateTime']  ? data['lastReportingDateTime'] : '-'}}</span>
                </td>
                <td class="qv-rep-type">
                    <span>{{ data['lastReportingType']  ? data['lastReportingType'] : '-'}}</span>
                </td>
                <td class="qv-city-state">
                    <span>{{ data['lastReportingCityState']  ? data['lastReportingCityState'] : '-'}}</span>
                </td>
                <td [style]="{'width':'150px'}">
                    <span>{{ data['oprtngRegionName']  ? data['oprtngRegionName'] : '-'}}</span>
                </td>
                <td [style]="{'width':'165px'}">
                    <span>{{ data['oprtngZoneName']  ? data['oprtngZoneName'] : '-'}}</span>
                </td>
                <td class="qv-tmc-status">
                    <span>{{ data['tmc']  ? data['tmc'] : '-'}}</span>
                </td>
                <td class="qv-locomotives">
                    <span>{{ data['locoData']}}</span>
                </td>

            </tr>
        </ng-template>
    </p-table>
</div>

<p-overlayPanel #overlayMenuLinks [dismissable]="true" id='overlayLinksInfo' [ngClass]="'menu-dropdown'">
    <ul>
        <li *ngFor="let link of overlayLinks">
            <a href="javascript:void(0)" (click)='routeToPage(link.label, contextType, contextSearchText); hideOverlayPanel($event, overlayMenuLinks);'>{{link.label}}</a>
        </li>
    </ul>
</p-overlayPanel>